//Components
import Grid from '@mui/material/Grid';
import SurveyQuestionCard from '../../MySurveys/SurveyQuestionCard/SurveyQuestionCard';

const SurveyTemplatePreview = ({ questions = [], disabled }) => {
  let questionIndex = 0;

  return (
    <Grid container rowspacing={1} columnspacing={{ xs: 1, sm: 2, md: 3 }} >
      {questions && questions?.length ? (
        questions?.map((item, index) => {
          if (item?.type?.value !== 'groupreference') {
            questionIndex += 1;
          }
          return (
            <SurveyQuestionCard
              key={index + 1}
              question={item}
              index={questionIndex}
              disabled={disabled}
              onChangeAlert={() => {}}
            />
          );
        })
      ) : (
        <></>
      )}
    </Grid>
  );
};
export default SurveyTemplatePreview;
